import { Component, OnInit, OnDestroy, ElementRef, AfterViewInit, Renderer, Input } from '@angular/core';
import * as ko from 'knockout';

@Component({
    selector: 'dk-currency-rates-column',
    template: require('./currency-rates-column.html')
})

export class CurrencyRatesColumnComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() onClose: () => void;

    constructor(private element: ElementRef, private renderer: Renderer) {

    }

    ngOnInit() {
        ko.applyBindings({}, this.element.nativeElement);
    }

    ngOnDestroy() {
        ko.removeNode(this.element.nativeElement);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            let element = this.element.nativeElement.children[0];
            this.renderer.listen(element.children[0], 'touchend', (event) => {
                event.stopPropagation();
                this.onClose();
            });

            this.renderer.listen(element.children[0], 'click', (event) => {
                event.stopPropagation();
                this.onClose();
            });

            this.renderer.listen(element.children[0].children[0], 'touchend', (event) => {
                event.stopPropagation();
            });

            this.renderer.listen(element.children[0].children[0], 'click', (event) => {
                event.stopPropagation();
            });
        }, 0);
    }
}
